module.exports = __webpack_public_path__ + "static/media/icons-20.cef8cdbb.woff";